module.exports = __webpack_public_path__ + "static/bfb-video-458bd6bd6e5caef6d69fe069a847a8be.mp4";